import React from 'react';
import {
    CheckBadgeIcon,
    ShieldCheckIcon,
    SparklesIcon,
    BanknotesIcon,
    LockOpenIcon,
    RocketLaunchIcon
} from '@heroicons/react/24/outline';

const Upgrade = () => {
    // LINK REAL DO MERCADO PAGO ATUALIZADO
    const MERCADO_PAGO_LINK = process.env.REACT_APP_MERCADO_PAGO_LINK;

    const handlePayment = () => {
        window.open(MERCADO_PAGO_LINK, '_blank');
    };

    return (
        <div className="min-h-[85vh] flex flex-col items-center justify-center p-6 animate-fade-in font-sans">
            {/* Glow Effect Background */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-emerald-500/10 blur-[150px] rounded-full -z-10"></div>

            <div className="text-center mb-12 space-y-6">
                <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-emerald-500/10 border border-emerald-500/30 text-emerald-400 text-[10px] font-black uppercase tracking-[0.3em] mb-4">
                    <SparklesIcon className="w-4 h-4" />
                    Acesso VIP Imediato
                </div>
                <h1 className="text-5xl md:text-7xl font-black italic text-white uppercase tracking-tighter leading-none">
                    VIRE UM <br />
                    <span className="text-emerald-500 drop-shadow-[0_0_30px_rgba(16,185,129,0.3)]">MESTRE PRO</span>
                </h1>
                <p className="text-gray-400 max-w-2xl mx-auto text-lg md:text-xl font-medium leading-relaxed">
                    O mercado não perdoa amadores. Desbloqueie agora o cronograma completo da <span className="text-white font-black italic">TraderFlix</span> e opere como os grandes bancos.
                </p>
            </div>

            <div className="w-full max-w-xl">
                <div className="bg-white/[0.03] backdrop-blur-3xl border border-emerald-500/30 rounded-[3.5rem] p-12 relative overflow-hidden group shadow-2xl shadow-emerald-500/10">
                    {/* Badge Recomendado */}
                    <div className="absolute top-12 right-[-45px] bg-emerald-500 text-black text-[10px] font-black py-2 px-14 uppercase tracking-[0.2em] rotate-45 shadow-xl z-20">
                        Acesso Total
                    </div>

                    <div className="mb-12 relative z-10">
                        <h3 className="text-2xl font-black text-white italic uppercase mb-4 flex items-center gap-3">
                            <RocketLaunchIcon className="w-8 h-8 text-emerald-500" />
                            Plano Anual
                        </h3>
                        <div className="flex items-baseline gap-2">
                            <span className="text-6xl font-black text-white tracking-tighter">R$ 399</span>
                            <span className="text-emerald-500 font-black uppercase text-sm tracking-widest italic">/ Anual</span>
                        </div>
                        <p className="text-gray-500 text-sm mt-4 font-bold uppercase tracking-wider">Investimento para sua liberdade financeira.</p>
                    </div>

                    <div className="space-y-6 mb-12 relative z-10">
                        {[
                            'Acesso a todas as Séries Originais',
                            'Leitura de Barras Elefantes e Elliot',
                            'Planilhas de Position Sizing inclusas',
                            'Psicologia de Mindset Vencedor',
                            'Suporte VIP via Comunidade',
                            'Certificados e Mentorias',
                        ].map((feature, j) => (
                            <div key={j} className="flex items-center gap-4 text-gray-300 font-bold group/item">
                                <div className="w-6 h-6 rounded-full bg-emerald-500/20 flex items-center justify-center border border-emerald-500/20 group-hover/item:bg-emerald-500 group-hover/item:text-black transition-all">
                                    <CheckBadgeIcon className="w-4 h-4" />
                                </div>
                                <span className="text-sm md:text-base tracking-wide whitespace-nowrap">{feature}</span>
                            </div>
                        ))}
                    </div>

                    <button
                        onClick={handlePayment}
                        className="w-full py-6 bg-emerald-600 hover:bg-emerald-500 text-white font-black rounded-3xl text-xl uppercase tracking-[0.1em] transition-all shadow-2xl shadow-emerald-600/30 active:scale-[0.98] flex items-center justify-center gap-4 relative z-10 group"
                    >
                        Assinar via Mercado Pago
                        <div className="w-2 h-2 rounded-full bg-white animate-ping"></div>
                    </button>

                    <p className="text-center mt-6 text-[10px] text-gray-500 font-bold uppercase tracking-[0.3em] relative z-10">
                        Liberação rápida após confirmação
                    </p>
                </div>
            </div>

            <div className="mt-16 flex flex-wrap justify-center gap-10 opacity-50">
                <div className="flex items-center gap-2 text-xs font-black uppercase tracking-widest text-white">
                    <ShieldCheckIcon className="w-5 h-5 text-emerald-500" />
                    Segurança Mercado Pago
                </div>
                <div className="flex items-center gap-2 text-xs font-black uppercase tracking-widest text-white">
                    <BanknotesIcon className="w-5 h-5 text-emerald-500" />
                    Pix e Cartão em até 12x
                </div>
                <div className="flex items-center gap-2 text-xs font-black uppercase tracking-widest text-white">
                    <LockOpenIcon className="w-5 h-5 text-emerald-500" />
                    Matrícula Imediata
                </div>
            </div>
        </div>
    );
};

export default Upgrade;
